import { TextField } from '@mui/material';
import React from 'react'
//import swal from 'sweetalert';

const FormTextField = ({label,className='',name,value,onBlurUpdate,type='',width=false}) => {
    //console.log('textform value',value)
    const [inputValue, setInputValue] = React.useState(value);
    const [inputType, setInputType] = React.useState('');

    React.useEffect(() => {
        setInputValue(value);
    },[value]);

    const handleChange = (e) => {
        let value = type === 'modbus' ?  e.target.value.replace(/\D/g, "") : e.target.value;
        if(type === 'modbus'){
            if((value < 1 || value > 9999) && (value < 40001 || value > 49999)){
                setInputValue('');
                return false;
            }
            if((value >= 40001 && value <= 49999) && (value % 2 === 0)){
                setInputValue('');
                return false;
            }
        }
        setInputValue(value);
        setInputType(e.target.type);
    } 

    const handleBlur = () => {
        // if(type === 'modbus' && inputValue !== ''){
        //     if((inputValue < 1 || inputValue > 9999) && (inputValue < 40001 || inputValue > 49999)){
        //         swal("Oops!", "Please use range between 1-9999 and 40001-49999 only.", "error");
        //         //setInputValue('');
        //         return false;   
        //     }
        //     if((inputValue >= 40001 && inputValue <= 49999) && (inputValue % 2 === 0)){
        //         swal("Oops!", "For range between 40001-49999 use only Odd numbers.", "error");
        //         //setInputValue('');
        //         return false; 
        //     }
        // }
       // console.log('inputValue',inputValue)
        onBlurUpdate(name,inputValue,inputType);
    } 

  return (
    <TextField
       // sx={{pb: }}
        //fullWidth={width === true ? true : false}
        sx={{ 
            width: { 
                xs:'100%', 
                sm:width === false ? '30%' : '100%',  
                md:width === false ? '24%' : '100%' 
            } 
        }}
        className={className}
        margin="dense"
        id={name}
        label={label}
        name={name}
        value={inputValue || ''}
        onBlur={handleBlur}
        onChange={handleChange}
        disabled={(name === 'Addr') ? true : false} 
        InputLabelProps={{
            shrink: true
        }}
        // sx={{
        //     // Root class for the input field
        //     "& .MuiOutlinedInput-root": {
        //         color: "#2e2e2e",
        //       "& .MuiOutlinedInput-notchedOutline": {
        //         borderColor: "#2e2e2e",
        //         borderWidth: "2px",
        //       },
        //     },
        //     // Class for the label of the input field
        //     "& .MuiInputLabel-outlined": {
        //       color: "#2e2e2e",
        //     },
        //   }}
    />
  )
}

export default FormTextField